export default {
  translation: {
    'xCloud': '云游戏',
    'Configuration obtained successfully, initiating offer...': '获取配置成功，开始发起offer...',
    'Remote offer retrieved successfully...': '远程offer获取成功...',
    'Ready to send ICE...': '准备发送ICE...',
    'Exchange ICE successfully...': 'ICE交换成功, 正在建立连接...',
    'Configuring ICE, waiting for response...': '正在配置ICE，正在等待响应...',
    'Connected': '连接成功',
    'Connecting...': '正在连接...',
    'Disconnecting...': '正在断开连接...',
    'Toggle Performance': '显示/隐藏性能信息',
    'Toggle Virtual Gamepad': '显示/隐藏虚拟手柄',
    'Disconnect': '断开连接',
    'Key Maping': '按键映射',
    'Please press the button on the controller, which will be mapped to:': '请按手柄上的按键，该按键将映射为:',
    'After successful mapping, this pop-up will automatically close': '映射成功后将自动关闭此弹窗',
    'Cancel': '取消',
    'Save': '保存',
    'Saving...': '保存中...',
    'Saved': '保存成功',
    'Reset': '恢复默认值',
    'Please press the button on the gamepad; this button will be mapped to:': '请按手柄上的按键，该按键将映射为:',
    'After successful mapping, this popup will automatically close.': '映射成功后将自动关闭此弹窗',
    'Warning': '提示',
    'The terminal seems to have been without a screen for a long time. Please try reconnecting.': '终端似乎很久没有返回画面，可以尝试点击确定按键刷新串流凭据并重新连接。',
    'NAT traversal failed. If you were attempting remote streaming and it was successful before, please click the refresh button below to refresh the streaming credentials and try again.': 'NAT打洞失败，如果你是尝试远程串流并之前成功过，请点击下方刷新按钮刷新串流凭据重试，重试多次依旧无法连接请稍后再试。',
    'Keep waiting': '继续等待',
    'Exit': '退出',
    'Refresh': '刷新',
    'Resolution': '分辨率',
    RTT: '延时',
    FPS: '帧数',
    FD: '掉帧',
    PL: '丢包',
    Bitrate: '码率',
    DT: '解码',
  }
}